var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"wit",class:`wit--${_vm.type}`},[_c('v-icon',{staticClass:"wit__icon",attrs:{"x-small":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.$t(`waste_item_type_${_vm.type}`))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }